export default "__VITE_ASSET__Cs6R$lfl__"